<app-dialog-wrapper
    heading="request.requestDetail.reassignRequestDialog.title"
    description="request.requestDetail.reassignRequestDialog.description"
    confirmLabel="request.requestDetail.reassignRequestDialog.emea.confirm"
    cancelLabel="request.requestDetail.reassignRequestDialog.emea.cancel"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <sh-team-picker
        label="{{ 'request.requestInformation.team' | translate }}"
        [formControl]="selectedTeam"
    ></sh-team-picker>
    <sh-user-picker
        label="{{ 'request.requestInformation.assignee' | translate }}"
        [formControl]="selectedUser"
        [roles]="[rolesEnum.TASK_OWNER]"
    ></sh-user-picker>
</app-dialog-wrapper>
